import React from 'react';
import EcoAssociation12Class2025 from 'views/EcoAssociation12Class2025';

const AccountGeneralPage = () => {
  return <EcoAssociation12Class2025/>;
};

export default AccountGeneralPage;